import { ButtonHTMLAttributes, CSSProperties, ReactNode } from 'react';
import { IChildrenProp, IOnlyIcon, ISize } from '../components.interface';

export enum BUTTON_VARIANT {
  default,
  submit,
  // clear,
  white,
  black,
  abort,
  remove,
  warning,
  background,
}

export interface IButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement>,
    IChildrenProp,
    IOnlyIcon,
    ISize {
  variant?: BUTTON_VARIANT;
  wrapperClassNames?: string;
  isActive?: boolean;
  fullWidth?: boolean;
  outsideChildren?: ReactNode;
  buttonStyle?: CSSProperties;
  isLoading?: boolean;
  isClear?: boolean;
}
